export default __webpack_public_path__ + "static/media/pinkspacedestactive3.858dac24.png";